import Service, { service } from '@ember/service';
import type ApiService from 'tio-employee/services/api';
import type { DigitalAssetDetailSignature } from 'tio-common/services/digital-assets';
import type {
  SlrLoanStandingAuditState,
  SlrLoanStandingCurrentStateResponse,
  SlrLoanStandingDocumentUploadPayload,
} from 'tio-employee/types/slr-loan-standing-verification';

type CurrentStatePayload = SlrLoanStandingAuditState | SlrLoanStandingCurrentStateResponse | null;

export default class SlrLoanStandingVerificationService extends Service {
  @service declare api: ApiService;

  fetchCurrentState = async (personId: string) => {
    const response = (await this.api.call<CurrentStatePayload>(
      `/people/${personId}/slr-loan-standing-verification/current`
    )) as CurrentStatePayload;

    return this.normalizeCurrentState(response);
  };

  createVerificationDocument = async (
    employeePlanAccountId: string,
    asset: DigitalAssetDetailSignature
  ) => {
    const payload: SlrLoanStandingDocumentUploadPayload = { asset };
    return (await this.api.post<SlrLoanStandingAuditState>(
      `/employee-plan-accounts/${employeePlanAccountId}/slr-loan-standing-verification/documents`,
      payload
    )) as SlrLoanStandingAuditState;
  };

  confirmNameMatch = async (employeePlanAccountId: string, confirmed: boolean) => {
    return (await this.api.post<SlrLoanStandingAuditState>(
      `/employee-plan-accounts/${employeePlanAccountId}/slr-loan-standing-verification/name-match-confirmation`,
      { confirmed }
    )) as SlrLoanStandingAuditState;
  };

  private normalizeCurrentState = (payload: CurrentStatePayload) => {
    if (!payload) return null;
    if ('status' in payload) return payload;

    return (
      payload.currentAuditState ??
      payload.loanStandingVerification ??
      payload.slrLoanStandingVerification ??
      null
    );
  };
}
